

export default function AverageCountForOverlappingTaxon({ subSampleTaxaData, rank }) {
    // console.log("subSampleTaxaData.length:", subSampleTaxaData.length);


    const processedData = Object.entries(subSampleTaxaData).map(([sampleId, sampleTaxaData]) => {
        const filteredByRank = sampleTaxaData.filter(item => item.taxon.rank === rank);
        return { sampleId, filteredByRank }
    });

    let taxonCounts = {};
    // console.log("processedData.length:", processedData.length);

    processedData.forEach(sample => {
        sample.filteredByRank.forEach(item => {
            const taxonId = item.taxon.ncbi_id;
            if (!taxonCounts[taxonId]) {
                taxonCounts[taxonId] = {
                    name: item.taxon.name,
                    count: 0
                };
            }
            taxonCounts[taxonId].count += item.count;
        });
    });

    const intersectingTaxa = processedData.reduce((commonTaxa, sample) => {
        const sampleTaxaIds = sample.filteredByRank.map(item => item.taxon.ncbi_id);
        return commonTaxa.filter(taxonId => sampleTaxaIds.includes(taxonId));
    }, Object.keys(taxonCounts).map(Number));

    const result = intersectingTaxa.map(taxonId => ({
        taxonId,
        name: taxonCounts[taxonId].name,
        totalCount: taxonCounts[taxonId].count,
        avgCount: taxonCounts[taxonId].count / processedData.length
    }));

    console.log(result);

    return result;

}